import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Form, Icon } from "semantic-ui-react";
import { AuthStore } from "../../../stores/auth-store";

declare var toastr: any;

interface IAccountSetupProps{
	authStore?: AuthStore;
	onNext(): void;
}

interface IAccountSetupState{
	validForm: boolean;
	firstName: string;
	lastName: string;
	company: string;
}

@inject("authStore") @observer
export class AccountSetup extends React.Component<IAccountSetupProps, IAccountSetupState>{


	constructor(props, state){
		super(props, state);

		this.state = {"validForm": false, "firstName": "", "lastName": "", "company": ""};

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleTextChange = this.handleTextChange.bind(this);
	}

	async handleSubmit(e: any){
		e.preventDefault();
		e.stopPropagation();

		if(await this.props.authStore.completeSetup(this.state.firstName, this.state.lastName, this.state.company)){
			toastr.info("Settings Changed");
			console.log("settings changes, go to next");
			this.props.onNext();
			console.log("went to next");
		}
	}

	handleTextChange(e: any, {name, value}){
		this.setState({[name]: value}, () => {
			this.validateForm();
		});
	}

	validateForm(){
		if(this.state.firstName && this.state.firstName.length > 0 && this.state.lastName && this.state.lastName.length > 0 && this.state.company && this.state.company.length > 0){
			this.setState({"validForm": true});
		}
		else{
			this.setState({"validForm": false});
		}
	}

	render(){
		return(
			<div>
				<Form onSubmit={this.handleSubmit} style={{"textAlign": "left"}}>
					<Form.Field>
						<Form.Input required type="text" label="First Name" name="firstName" value={this.state.firstName} onChange={this.handleTextChange}  />
					</Form.Field>
					<Form.Field>
						<Form.Input required type="text" label="Last Name" name="lastName" value={this.state.lastName} onChange={this.handleTextChange}  />
					</Form.Field>
					<Form.Field>
						<Form.Input required type="text" label="Company" name="company" value={this.state.company} onChange={this.handleTextChange}  />
					</Form.Field>
					<Button type="submit" icon className="jibunu-green" labelPosition="left" disabled={!this.state.validForm}>
						<Icon name="arrow circle right" />
							Next
					</Button>
				</Form>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/forms/account-setup.tsx